export const getCurrentLocale = function() {
    let locale = localStorage.getItem('asi.locale');

    // Retrieve locale from browser
    if(!locale) {
        locale = navigator.language.substring(0, 2);
    }

    return locale;
}

export const setCurrentLocale = function (locale, i18n) {
    localStorage.setItem('asi.locale', locale);
    i18n.locale = locale;
}
